import querystring from 'querystring';

const isProduction = process.env.NODE_ENV === 'production';
const isStaging = process.env.NODE_ENV === 'staging';
const isDevelopment = !isProduction && !isStaging;
/**
 * 許容パラメータ例
 * debug=1
 * paorama=03
 * autorotate=1.5
 */
const paramStr = location.search.substring(1);
const params = !isProduction && paramStr ? querystring.parse(paramStr) : {};

const isDebug = params.debug !== undefined ? Boolean(params.debug) : false;
const measureMode = params.measure !== undefined ? Boolean(parseInt(params.measure)) : false;

const appConfig = {
  // デバッグ・開発設定
  debug: {
    visibleHelper: isDebug,
    visibleHitArea: isDebug,
    visiblePanoramaId: isDebug,
    measureMode: measureMode,
    suppressIntro: false,
    outputPosition: isProduction ? false : true,
  },

  // ロード時に乱数を含める
  panoramaConfigNoCache: true,
  // 初期画面ID
  initialPanoramaId: params.panorama !== undefined ? params.panorama : '01',
  // CookieConsentダイアログの有効化
  cookieConsentEnabled: false,
  // WelcomeScreenの有効化
  welcomeScreenEnabled: true,
  // 3秒後にAutoRotate＋Speed
  autoRotateEnabled: params.autorotate !== undefined,
  autoRotateSpeed: params.autorotate !== undefined ? parseFloat(params.autorotate) : 1.0,
  // Intro動画をパノラマ画像読み込み後に開始する。falseの場合は前画面の遷移時に開始する。
  playIntroOnEnter: true,

  // FOV最大最小値
  minFov: 30,
  maxFov: 100,

  // 商品IDクエリパラメータ用セパレータ
  pidSeparator: '|',

  // 商品詳細DB
  productDataPath: isDevelopment ? '' : '/db2',
  // GA
  analyticsCode: isDevelopment ? null : null,
  appVersion: '1.0.0',

  // 時代毎のHome画面ID
  eraHome: {
    'present': '01',
    'modern': '02',
    'medieval': '03',
    'ancient': '04',
  },
};
export default appConfig;